import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IState } from './IState';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StateLookupService {
  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/StatesUS`;

  public get (): Observable<Array<IState>> {
    this.log.verbose({ type: 'StateLookupService:get', uri: this.uri });
    return this.http.get<Array<IState>>(this.uri)
      .pipe(
        tap(res => this.log.verbose({ type: 'StateLookupService:reponse', res }))
      )
      ;
  }
}
